(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const variantData = (() => {
    try {
      return JSON.parse($("[data-product-variant-data]")?.textContent || "{}").variants || [];
    } catch (error) {
      return [];
    }
  })();

  const getSelectedOptions = () => $$('[data-option-select]').map((select) => select.value);

  const getSelectedVariant = () => {
    const options = getSelectedOptions();
    return variantData.find((variant) => options.every((value, index) => variant.options?.[index] === value)) || variantData[0] || null;
  };
  const isMeaningfulFinish = (value = '') => {
    const normalized = String(value || '').trim();
    return normalized && !/^default(?:\s+title)?$/i.test(normalized);
  };

  const syncVariantPreview = () => {
    const variant = getSelectedVariant();
    if (!variant) return;

    const rawFinish = variant.options?.[0] || variant.title || '';
    const finish = isMeaningfulFinish(rawFinish) ? String(rawFinish).trim() : '';
    const label = $('[data-product-finish-label]');
    if (label) {
      label.textContent = document.body.classList.contains('template-product') && finish ? 'Finish shown: ' + finish : 'Product shown';
    }

    const image = $('[data-product-preview-image]');
    if (image) {
      const title = $('h1')?.textContent?.trim() || 'Dominator product';
      image.setAttribute('alt', finish ? title + ' ' + finish : title + ' product image');
      if (variant.featuredImage) {
        image.setAttribute('src', variant.featuredImage);
        image.removeAttribute('srcset');
      }
    }
  };

  if (variantData.length) {
    $$('[data-option-select]').forEach((select) => {
      select.addEventListener('change', () => requestAnimationFrame(syncVariantPreview));
    });
    $$('[data-variant-pill]').forEach((button) => {
      button.addEventListener('click', () => setTimeout(syncVariantPreview, 0));
    });
    // Keep initial gallery aligned with the React PDP; swap finish media only after user selection.
  }

  const sticky = $('[data-sticky-add-to-cart]');
  const productForm = $('[data-product-form]');
  const stickyButton = sticky ? $('[data-sticky-add-button]', sticky) : null;
  const mainButton = productForm ? $('[data-product-add-submit]', productForm) : null;

  const updateStickyVisibility = () => {
    if (!sticky || !productForm) return;
    const rect = productForm.getBoundingClientRect();
    const normalControlsVisible = rect.top < window.innerHeight - 112 && rect.bottom > 96;
    const shouldShow = window.scrollY > 420 && !normalControlsVisible;
    sticky.classList.toggle('is-visible', shouldShow);
    document.body.classList.toggle('has-sticky-cart-visible', shouldShow);
  };

  if (sticky && productForm) {
    updateStickyVisibility();
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility);
  }

  if (mainButton && stickyButton) {
    const mirrorButtonState = () => {
      const text = mainButton.textContent.trim();
      if (text === 'Adding' || text === 'Added') {
        stickyButton.disabled = true;
        stickyButton.textContent = text;
      } else if (stickyButton.textContent.trim() === 'Adding' || stickyButton.textContent.trim() === 'Added') {
        stickyButton.disabled = false;
        stickyButton.textContent = 'Add to cart';
      }
    };

    new MutationObserver(mirrorButtonState).observe(mainButton, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true,
    });
    mainButton.addEventListener('click', () => setTimeout(mirrorButtonState, 0));
    mirrorButtonState();
  }
})();


/* 2026-06-16 rendered QA defect pass: selected-finish media, sticky cart, overlay state. */
(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const variantData = (() => {
    try {
      return JSON.parse($('[data-product-variant-data]')?.textContent || '{}').variants || [];
    } catch (error) {
      return [];
    }
  })();
  const selectedOptions = () => $$('[data-option-select]').map((select) => select.value);
  const selectedVariant = () => {
    const options = selectedOptions();
    return variantData.find((variant) => options.every((value, index) => variant.options?.[index] === value)) || variantData[0] || null;
  };
  const productTitle = () => $('h1')?.textContent?.trim() || $('[data-product-root]')?.dataset.productHandle || 'Dominator product';
  const isMeaningfulFinish = (value = '') => {
    const normalized = String(value || '').trim();
    return normalized && !/^default(?:\s+title)?$/i.test(normalized);
  };
  const setImage = (image, src, alt) => {
    if (!image) return;
    if (src) {
      image.setAttribute('src', src);
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
    }
    image.setAttribute('alt', alt);
  };
  const syncSelectedFinishSurfaces = () => {
    const variant = selectedVariant();
    if (!variant) return;
    const rawFinish = variant.options?.[0] || variant.title || '';
    const finish = isMeaningfulFinish(rawFinish) ? String(rawFinish).trim() : '';
    const title = productTitle();
    const alt = finish ? title + ' ' + finish : title + ' product image';
    const imageSrc = variant.featuredImage || '';

    $$('[data-product-finish-label]').forEach((node) => {
      node.textContent = document.body.classList.contains('template-product') && finish ? 'Finish shown: ' + finish : 'Product shown';
    });
    $$('[data-product-price-note]').forEach((node) => {
      node.textContent = finish ? finish + ' finish price. Other finishes may vary.' : '';
      node.hidden = !finish;
    });
    $$('[data-product-preview-image]').forEach((image) => setImage(image, imageSrc, alt));
    $$('[data-product-media-main] img').forEach((image) => setImage(image, imageSrc, alt));
    $$('[data-product-media-main] [data-media-caption-label]').forEach((node) => {
      node.textContent = finish ? 'Selected finish' : 'Product shown';
    });
    $$('[data-product-media-main] [data-media-caption-title]').forEach((node) => {
      node.textContent = finish || title;
    });
  };

  if (variantData.length) {
    $$('[data-option-select]').forEach((select) => select.addEventListener('change', () => requestAnimationFrame(syncSelectedFinishSurfaces)));
    $$('[data-variant-pill]').forEach((button) => button.addEventListener('click', () => setTimeout(syncSelectedFinishSurfaces, 0)));
    // Initial PDP media stays on the hero/court view; variant media sync runs after selection.
  }

  const sticky = $('[data-sticky-add-to-cart]');
  const productForm = $('[data-product-form]');
  const mainButton = $('[data-product-add-submit]', productForm || document);
  const stickyButton = $('[data-sticky-add-button]', sticky || document);
  const updateStickyVisibility = () => {
    if (!sticky || !mainButton) return;
    const rect = mainButton.getBoundingClientRect();
    const passedMainControls = rect.bottom < 80;
    const shouldShow = window.scrollY > 320 && passedMainControls && !mainButton.disabled;
    sticky.classList.toggle('is-visible', shouldShow);
    document.body.classList.toggle('has-sticky-cart-visible', shouldShow);
  };
  const mirrorStickyButtonState = () => {
    if (!mainButton || !stickyButton) return;
    const label = mainButton.textContent.trim();
    const transient = label === 'Adding' || label === 'Added';
    stickyButton.disabled = transient || mainButton.disabled;
    if (transient) stickyButton.textContent = label;
    else if (stickyButton.textContent.trim() === 'Adding' || stickyButton.textContent.trim() === 'Added') stickyButton.textContent = 'Add to cart';
    updateStickyVisibility();
  };
  if (sticky && mainButton) {
    updateStickyVisibility();
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility);
    new MutationObserver(mirrorStickyButtonState).observe(mainButton, { attributes: true, childList: true, characterData: true, subtree: true });
    mainButton.addEventListener('click', () => setTimeout(mirrorStickyButtonState, 0));
    mirrorStickyButtonState();
  }

  const supportDrawer = $('[data-support-drawer]');
  const syncOverlayState = () => {
    const supportOpen = Boolean(supportDrawer && !supportDrawer.hidden);
    document.body.classList.toggle('support-open', supportOpen);
    if (supportOpen) $('[data-thumb-nav]')?.classList.remove('is-open');
  };
  if (supportDrawer) {
    syncOverlayState();
    new MutationObserver(syncOverlayState).observe(supportDrawer, { attributes: true, attributeFilter: ['hidden'] });
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-support-open], [data-support-close]')) setTimeout(syncOverlayState, 0);
    });
  }
})();
